import { Mailbox } from "./TenantAPI";

/**
 * The mailbox with its POP3/SMTP settings filled in where the API left them out.
 *
 * The API omits null fields from its JSON, so a blank setting arrives as a
 * missing key. An input given `undefined` stops being controlled and keeps
 * showing the previous mailbox's text, so blank ports become `null` and blank
 * text becomes `""`.
 */
export function withServerSettingDefaults(mailbox: Mailbox): Mailbox {
    return {
        ...mailbox,
        pop3Server: mailbox.pop3Server ?? "",
        pop3Port: mailbox.pop3Port ?? null,
        pop3Username: mailbox.pop3Username ?? "",
        pop3Password: mailbox.pop3Password ?? "",
        smtpServer: mailbox.smtpServer ?? "",
        smtpPort: mailbox.smtpPort ?? null,
        mailboxConfiguration: {
            ...mailbox.mailboxConfiguration,
            pop3Settings: mailbox.mailboxConfiguration?.pop3Settings ?? "",
            smtpSettings: mailbox.mailboxConfiguration?.smtpSettings ?? "",
        },
    };
}
